import React from "react";
import pdfFile from "../pdfs/Tipkit-BelldeskGuide-spanish.pdf";
import PdfViewer from "../comman/PdfViewer";

const BellStaffGuideSpanish = () => {
    return <PdfViewer pdfFile={pdfFile} />;
};

export default BellStaffGuideSpanish;
